export const PUBLIC_WELFARE_PROJECT_RESOURCES_ID = 24

export const BROWSER_SIZE_LEVEL = {
    none: 0,
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5,
}